// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ad198ea","453":"ebc9752a","455":"76a14dfc"}[chunkId] + ".chunk.js";
};